import { MemoryReactionsStore, ReactionServiceClient } from '@atlaskit/reactions';
import getServiceBaseUrl from './service-repo.tsx';

const url = () => getServiceBaseUrl('reactions') || '';
const client = () => new ReactionServiceClient(url());
const store = () => new MemoryReactionsStore(client());

export { store };
